module.exports = __webpack_public_path__ + "static/OldMansJourney4-ec9d4e747581925fadb3ca318a639e7c.webp";